import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@components/ui/empty';
import { ShieldCheckIcon } from '@heroicons/react/outline';

export const EmptyValidation = () => {
  return (
    <Empty className="md:p-6">
      <EmptyHeader>
        <EmptyMedia variant="icon" className="rounded-full">
          <ShieldCheckIcon />
        </EmptyMedia>
        <EmptyTitle className="text-sm font-medium">No validation selected</EmptyTitle>
        <EmptyDescription className="text-xs/relaxed">
          Try adjusting your filters to see more validation.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
